export const GET_SEDI_DATA_AND_LOADING = "GET_SEDI_DATA_AND_LOADING";
export const GET_SEDI_DETAILS_AND_LOADING = "GET_SEDI_DETAILS_AND_LOADING";
export const EXPORT_SEDI_LOADING = "EXPORT_SEDI_LOADING";
